/**
 * Application Route Constants
 * Centralizes route path definitions for type-safe navigation
 */
export const ROUTES = {
  /**
   * Root path
   */
  ROOT: '/',

  /**
   * Public matches default redirect
   */
  PUBLIC_MATCHES: '/public/matches',

  /**
   * Event details route pattern
   */
  EVENT: '/event/:id',

  /**
   * Public schedule route pattern
   */
  PUBLIC_SCHEDULE: '/schedule/:key',

  /**
   * Public standings route pattern
   * Single season key (the competition_seasons.key slug); no season segment
   */
  PUBLIC_STANDINGS: '/standings/:key',
} as const;
